import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthentication } from '../../hooks/useAuthentication';
import LoginForm from '../../components/LoginForm/LoginForm';
import { Card } from '../../components/ui';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, error: authError, loading } = useAuthentication();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await login({ email, password });
    if (res?.success) navigate('/profile');
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12 bg-bg">
      <div className="w-full max-w-[420px]">
        <Card>
          <Card.Body className="py-8 px-6">
            <LoginForm
              email={email}
              password={password}
              setEmail={setEmail}
              setPassword={setPassword}
              handleSubmit={handleSubmit}
              loading={loading}
              error={authError}
            />
          </Card.Body>
        </Card>

        <p className="mt-6 text-center text-xs text-text-muted">
          Ao entrar, você concorda com os nossos{' '}
          <span className="text-text-secondary">termos de uso</span>.
        </p>
      </div>
    </div>
  );
}
